// 自定义提示框工具函数
import Vue from 'vue'
import CustomToast from '@/components/custom/CustomToast.vue'

// 创建一个Vue实例来挂载自定义提示组件
const ToastConstructor = Vue.extend(CustomToast)
let toastInstance = null

// 显示自定义提示
export function showCustomToast (options) {
  // 关闭之前的提示
  if (toastInstance) {
    toastInstance.visible = false
  }

  // 创建新的提示实例
  toastInstance = new ToastConstructor({
    propsData: options
  })

  // 挂载到DOM
  toastInstance.$mount()
  document.body.appendChild(toastInstance.$el)

  // 显示提示
  toastInstance.visible = true

  // 监听关闭事件
  toastInstance.$on('close', () => {
    toastInstance.visible = false
    // 移除DOM元素
    setTimeout(() => {
      if (toastInstance && toastInstance.$el) {
        document.body.removeChild(toastInstance.$el)
        toastInstance = null
      }
    }, 300)
  })

  return toastInstance
}

// 导出默认方法
export default {
  show: showCustomToast
}



// WEBPACK FOOTER //
// ./src/assets/js/customToast.js